import {
  type CategorizedResponse,
  LodgingSelectionEnum,
  type Suggestion,
  PlaceIdEnum,
  lodgingApi,
  LocationQueryEnum,
} from "@b2bportal/lodging-api";
import { axiosInstance } from "@hopper-b2b/api";

export const fetchLodgingLocationAutocomplete = async (
  query: string
): Promise<CategorizedResponse[]> => {
  const res = await lodgingApi(axiosInstance).apiV0AutocompleteLodgingPost({
    query: { l: query, LocationQuery: LocationQueryEnum.Label },
  });
  return res.data.categories;
};

export const fetchLocationByLabelAndId = async (
  label: string,
  locationId?: string
): Promise<Suggestion | undefined> => {
  const locations = await fetchLodgingLocationAutocomplete(label);

  if (!locations || locations.length === 0 || !locations[0].results) {
    return undefined;
  }

  const allResults = locations[0].results;

  // If locationId is provided, try to find exact match
  if (locationId) {
    const exactMatch = allResults.find(
      (location: Suggestion) => location.id.Id === locationId
    );
    if (exactMatch) {
      return exactMatch;
    }
  }

  // Try to find a geo location
  const geoLocation = allResults.find(
    (location: Suggestion) =>
      location.id.Id === PlaceIdEnum.Lodgings &&
      location.id.lodgingSelection.LodgingSelection ===
        LodgingSelectionEnum.Place &&
      location.id.lodgingSelection.placeTypes.includes("geocode")
  );

  // Return geo location or first location
  return geoLocation ?? allResults[0];
};

export { usePlaceFromLodgingSelection } from "./usePlaceFromLodgingSelection";
